export default __webpack_public_path__ + "static/media/download.956d70f2.svg";